import { SiteActions } from "../actions/site";
import HelperUtil from "../../helpers/utils";

const INITIAL_STATE = {
  reports: {},
  sites: [],
  sitesLoading: true,
  info: {},
  selectedSite: null,
  selectedSiteLoading: true,
  selectedUser: null,
  selectedUserLoading: false,
};

function site(state = INITIAL_STATE, action) {
  let reports, sites;
  switch (action.type) {
    case SiteActions.CREATE_SITE:
      sites = state.sites.slice();
      sites.push(action.payload.site);
      return {
        ...state,
        sites,
      };
    case SiteActions.GET_SITE:
    case SiteActions.UPDATE_SITE:
      sites = state.sites
        .slice()
        .filter((site) => site.id !== action.payload.site.id);
      sites.push(action.payload.site);
      return {
        ...state,
        sites,
      };
    case SiteActions.SELECT_SITE:
      return {
        ...state,
        selectedSite: action.payload.site,
      };
    case SiteActions.SELECT_SITE_LOADING:
      return {
        ...state,
        selectedSiteLoading: action.payload,
      };
    case SiteActions.GET_SITE_REPORT:
      reports = Object.assign({}, state.reports);
      reports[HelperUtil.getMD5Hash(JSON.stringify(action.payload.params))] =
        action.payload.report;
      return {
        ...state,
        reports,
      };
    case SiteActions.GET_SITES:
      return {
        ...state,
        sites: action.payload.sites,
        info: action.payload.info,
      };
    case SiteActions.GET_SITES_LOADING:
      return {
        ...state,
        sitesLoading: action.payload,
      };
    case SiteActions.INVALIDATE_SITES:
      return INITIAL_STATE;
    case SiteActions.SELECT_USER:
      return {
        ...state,
        selectedUser: action.payload.user,
      };
    case SiteActions.SELECT_USER_LOADING:
      return {
        ...state,
        selectedUserLoading: action.payload,
      };
    default:
      return state;
  }
}

export default { site };
